export const FORM_STATUSES = {
    complete: "check",
    unseen: "exclamation",
    invalid: "exclamation",
    missingFields: false
}